
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSurfing as ObiSurfingElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-surfing.js';
 
 
 

 
 export const ObiSurfing = createComponent({
   react: React,
   tagName: 'obi-surfing',
   elementClass: ObiSurfingElement,
   events: {
     
   }
  });
 
 